import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div>
            <div className='banner-container'>
                <img className='banner' alt="banner" src="https://i.ytimg.com/vi/VCq4uJR_09U/maxresdefault.jpg" ></img>
            </div>

        </div>
    );
};

export default Banner;